import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4.4 6.419v11.497l.128-.035c.74-.194 1.838-.381 3.322-.381s2.582.187 3.322.381l.128.035V6.42a5.1 5.1 0 0 0-.53-.211c-.61-.207-1.572-.425-2.92-.425-1.348 0-2.31.218-2.92.425-.222.075-.398.149-.53.21Zm8 .161ZM12 5.202a6.283 6.283 0 0 0-.782-.32c-.753-.255-1.866-.499-3.368-.499-1.502 0-2.615.244-3.368.498a6.12 6.12 0 0 0-.857.36 3.727 3.727 0 0 0-.317.184l-.007.006-.003.002h-.002v.001l.404.572-.405-.571a.7.7 0 0 0-.295.57v12.912a.7.7 0 0 0 1.033.615h.002a5.669 5.669 0 0 1 .85-.296c.622-.164 1.6-.336 2.965-.336 1.366 0 2.343.172 2.966.335.311.082.535.163.674.219a2.662 2.662 0 0 1 .177.078.7.7 0 0 0 .666 0h.002l.028-.014c.028-.014.077-.036.147-.064.14-.056.363-.137.674-.219.623-.163 1.6-.335 2.966-.335s2.343.172 2.966.335c.311.082.535.163.674.219a2.662 2.662 0 0 1 .175.077l.002.001A.7.7 0 0 0 21 18.917V6.006a.7.7 0 0 0-.295-.571l-.405.57.404-.57v-.001l-.002-.001-.003-.002-.007-.006a1.315 1.315 0 0 0-.087-.056 3.756 3.756 0 0 0-.23-.129 6.117 6.117 0 0 0-.857-.359c-.753-.254-1.866-.498-3.368-.498-1.502 0-2.615.244-3.368.498-.33.112-.59.226-.782.321Zm7.6 1.217a5.1 5.1 0 0 0-.53-.211c-.61-.207-1.572-.425-2.92-.425-1.348 0-2.31.218-2.92.425a5.1 5.1 0 0 0-.53.21v11.498a8.98 8.98 0 0 1 .128-.035c.74-.194 1.838-.381 3.322-.381s2.582.187 3.322.381l.128.035V6.42Zm.363 13.111Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
